import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

function sanitizeFilename(part) {
  return String(part)
    .replace(/[^\w-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

function formatLeverdatumForFilename(leverdatumStr) {
  const formatted = String(leverdatumStr).match(/(\d{2})-(\d{2})-(\d{4})/);
  if (formatted) {
    return `${formatted[3]}${formatted[2]}${formatted[1]}`;
  }

  const iso = String(leverdatumStr).match(/(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return `${iso[1]}${iso[2]}${iso[3]}`;
  }

  return sanitizeFilename(leverdatumStr);
}

function buildTableRows(regels, vrijeRegels) {
  const rows = (regels || []).map((regel) => [
    String(regel.hoeveelheid),
    regel.product,
    regel.eenheid || '-'
  ]);

  (vrijeRegels || []).forEach((regel) => {
    rows.push([
      String(regel.hoeveelheid),
      `${regel.product || regel.omschrijving} (Anders)`,
      '-'
    ]);
  });

  return rows;
}

function addProductTable(doc, startY, regels, vrijeRegels) {
  autoTable(doc, {
    head: [['Hoeveelheid', 'Product', 'Eenheid']],
    body: buildTableRows(regels, vrijeRegels),
    startY,
    styles: { fontSize: 10, cellPadding: 4 },
    headStyles: { fillColor: [21, 101, 192], textColor: 255 },
    columnStyles: {
      0: { halign: 'center', cellWidth: 28 }
    },
    margin: { left: 14, right: 14 }
  });
}

export function exportCummulatieveLijstPdf(lijst) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  doc.setFontSize(16);
  doc.setTextColor(21, 101, 192);
  doc.text('Kampboodschappen – cumulatieve lijst', 14, 18);

  doc.setFontSize(11);
  doc.setTextColor(33, 33, 33);
  doc.text(`Leverdatum: ${lijst.leverdatum}`, 14, 28);
  doc.text(`Aantal bestellingen: ${lijst.aantal_bestellingen}`, 14, 35);

  const hasProducten = (lijst.regels?.length || 0) > 0 || (lijst.vrije_regels?.length || 0) > 0;
  if (hasProducten) {
    addProductTable(doc, 42, lijst.regels, lijst.vrije_regels);
  } else {
    doc.setFontSize(10);
    doc.setTextColor(120, 120, 120);
    doc.text('Geen producten in de cumulatieve lijst voor deze datum.', 14, 44);
  }

  const notitiesPerSpeltak = lijst.notities_per_speltak || [];
  if (notitiesPerSpeltak.length > 0) {
    doc.addPage();
    doc.setFontSize(16);
    doc.setTextColor(21, 101, 192);
    doc.text('Notities per speltak', 14, 18);

    doc.setFontSize(11);
    doc.setTextColor(33, 33, 33);
    doc.text(`Leverdatum: ${lijst.leverdatum}`, 14, 26);

    let y = 36;

    notitiesPerSpeltak.forEach((speltak) => {
      if (y > 265) {
        doc.addPage();
        y = 18;
      }

      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(230, 81, 0);
      const speltakTitel = speltak.speltak_naam.charAt(0).toUpperCase() + speltak.speltak_naam.slice(1);
      doc.text(speltakTitel, 14, y);
      y += 8;

      speltak.notities.forEach((item) => {
        if (y > 265) {
          doc.addPage();
          y = 18;
        }

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(100, 100, 100);
        doc.text(`Bestelling #${item.bestelling_id} · ${item.besteldatum}`, 14, y);
        y += 5;

        doc.setFontSize(10);
        doc.setTextColor(33, 33, 33);
        const lines = doc.splitTextToSize(item.notitie, 180);
        doc.text(lines, 14, y);
        y += lines.length * 5 + 8;
      });

      y += 4;
    });
  }

  const filename = `boodschappenlijst-${sanitizeFilename(lijst.leverdatum)}.pdf`;
  doc.save(filename);
}

export function exportBestellingPdf({ speltak_naam, bestelling, regels, vrijeRegels }) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  doc.setFontSize(16);
  doc.setTextColor(21, 101, 192);
  doc.text('Kampboodschappen – bestelling', 14, 18);

  doc.setFontSize(11);
  doc.setTextColor(33, 33, 33);
  doc.text(`Speltak: ${speltak_naam}`, 14, 28);
  doc.text(`Bestelnummer: #${bestelling.ID}`, 14, 35);
  doc.text(`Besteldatum: ${bestelling.besteldatum}`, 14, 42);
  doc.text(`Leverdatum: ${bestelling.leverdatum}`, 14, 49);
  doc.text(`Status: ${bestelling.status === 0 ? 'Open' : 'Gesloten'}`, 14, 56);

  let tableStartY = 63;
  if (bestelling.notitie) {
    doc.text('Notitie:', 14, 64);
    const notitieLines = doc.splitTextToSize(bestelling.notitie, 180);
    doc.text(notitieLines, 14, 71);
    tableStartY = 71 + notitieLines.length * 5 + 4;
  }

  addProductTable(doc, tableStartY, regels, vrijeRegels);

  const filename = `${sanitizeFilename(speltak_naam)}-${formatLeverdatumForFilename(bestelling.leverdatum)}-${bestelling.ID}.pdf`;
  doc.save(filename);
}
